export default {"src":"/_next/static/media/image-placeholder.e9918bcf.svg","height":48,"width":64,"blurWidth":0,"blurHeight":0};